import { useTranslation } from "next-i18next";
import { cn } from "../../../../../lib/utils";

const ASSETS_PATH = "/landings/assets/images/products/hub-talentos";

export default function InfosSection() {
	const { t } = useTranslation();

	return (
		<section className="hidden tablet:block relative overflow-hidden bg-neutral-08">
			{/* Background image - absolute, left side (tablet+) */}
			<div className="hidden tablet:block absolute left-0 top-1/2 -translate-y-1/2 tablet:w-[352px] tablet:h-[198px] laptop:w-[50%] laptop:h-[447px] laptopM:w-[736px]">
				<div className="absolute inset-0 overflow-hidden">
					<img
						src={`${ASSETS_PATH}/info-image.jpg`}
						alt={t("products.hub-talentos.infos.imageAlt")}
						className="absolute w-full h-full object-cover"
					/>
					<div
						className="absolute inset-0"
						style={{
							backgroundImage:
								"linear-gradient(to bottom, rgb(0, 0, 0) 2.5%, rgba(0, 0, 0, 0) 27%), linear-gradient(to left, rgb(0, 0, 0) 1.9%, rgba(0, 0, 0, 0) 36%), linear-gradient(90deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%)",
						}}
					/>
				</div>
			</div>

			{/* Mobile image (hidden on tablet+) */}
			<div className="tablet:hidden px-5 pt-10">
				<div className="relative overflow-hidden rounded-lg">
					<img
						src={`${ASSETS_PATH}/info-image.jpg`}
						alt={t("products.hub-talentos.infos.imageAlt")}
						className="w-full h-auto object-cover"
					/>
					<div
						className="absolute inset-0"
						style={{
							backgroundImage:
								"linear-gradient(to bottom, rgb(0, 0, 0) 2.5%, rgba(0, 0, 0, 0) 27%), linear-gradient(to left, rgb(0, 0, 0) 1.9%, rgba(0, 0, 0, 0) 36%), linear-gradient(90deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%)",
						}}
					/>
				</div>
			</div>

			{/* Text - pushed to right */}
			<div
				className={cn(
					"relative flex justify-start",
					"px-5 py-10",
					"tablet:justify-end tablet:px-[40px] tablet:py-[48px]",
					"laptop:px-[80px] laptop:py-[80px]",
				)}
			>
				<div className="w-full tablet:w-[410px] laptop:w-[50%] laptopM:w-[600px]">
					<p
						className={cn(
							"text-white mb-0 ml-0 mr-0 mt-0",
							"text-base leading-7",
							"tablet:text-sm tablet:leading-[22px]",
							"laptop:text-lg laptop:leading-8",
							"laptopM:text-xl laptopM:leading-8",
						)}
					>
						{t("products.hub-talentos.infos.paragraph1")}
					</p>
					<p
						className={cn(
							"text-white mb-0 ml-0 mr-0 mt-6",
							"text-base leading-7",
							"tablet:text-sm tablet:leading-[22px] tablet:mt-4",
							"laptop:text-lg laptop:leading-8 laptop:mt-8",
							"laptopM:text-xl laptopM:leading-8",
						)}
					>
						{t("products.hub-talentos.infos.paragraph2")}
					</p>
					<p
						className={cn(
							"!text-ds-brand-green-300 font-bold mb-0 ml-0 mr-0 mt-6",
							"text-base leading-7",
							"tablet:text-sm tablet:leading-[22px] tablet:mt-4",
							"laptop:text-xl laptop:leading-8 laptop:mt-8",
							"laptopM:text-2xl laptopM:leading-8",
						)}
					>
						{t("products.hub-talentos.infos.highlight")}
					</p>
				</div>
			</div>
		</section>
	);
}
